import { declensionByNum } from 'www/utils'
import i18next from 'i18next'
import { YEAR_CASES } from 'www/constants/wordCases'

const options = { ns: i18next.language }
const isCorrectAge = age => Boolean(typeof age === 'number' && age)
const getAgeCaseText = age => `${age}\u00A0${i18next.t(declensionByNum(age, YEAR_CASES.genitive), options)}`

function getSpecialityAgesText({ min, max }, { withBrackets = true } = {}) {
  const ageLimitsStrings = []

  if (isCorrectAge(min)) {
    ageLimitsStrings.push(`${i18next.t('от', options)}\u00A0${getAgeCaseText(min)}`)
  }

  if (isCorrectAge(max)) {
    ageLimitsStrings.push(`${i18next.t('до', options)}\u00A0${getAgeCaseText(max)}`)
  }

  if (!ageLimitsStrings.length) {
    return ''
  }

  return withBrackets
    ? ` (${ageLimitsStrings.join(' ')})`
    : ` ${ageLimitsStrings.join(' ')}`
}

export default getSpecialityAgesText
